import type { AnimationI, AnySceneObjectT } from "tweenly"
import { PayloadAction } from "@reduxjs/toolkit"
import {
    defaultAutoFrame,
    defaultEllipse,
    defaultFlexFrame,
    defaultFrame,
    defaultImage,
    defaultItem,
    defaultLine,
    defaultSvg,
    defaultText,
} from "../../../../data/defaults/objects.types.defaults"
import { ObjectsStateT } from "../../objects.slice"
import { PayloadObjectsAndAnimations } from "./objectTypes"

export const defaultObject = (type: string): AnySceneObjectT => {
    switch (type) {
        case "text":
            return defaultText
        case "image":
            return defaultImage
        case "frame":
            return defaultFrame
        case "flex-frame":
            return defaultFlexFrame
        case "auto-frame":
            return defaultAutoFrame
        case "svg":
            return defaultSvg
        case "ellipse":
            return defaultEllipse
        case "line":
            return defaultLine
        default:
            return defaultItem
    }
}

export const uploadObjectsAndAnimationsBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<PayloadObjectsAndAnimations>
) => {
    const objects: AnySceneObjectT[] = action.payload.objects
    const animations: AnimationI[] = action.payload.animations

    objects.forEach((object) => {
        const objectAnimations = animations.reduce((acc, animation) => {
            if (animation.objectId === object.id) {
                return {
                    ...acc,
                    [animation.id]: animation,
                }
            }
            return acc
        }, {} as Record<string, AnimationI | undefined>)

        state.value = {
            ...state.value,
            [object.id]: {
                ...object,
                animations: objectAnimations,
            },
        }
    })
}
